export default function registerPolyline (lf) {
  lf.register('polyline', ({ PolylineEdge, PolylineEdgeModel }) => {
    class ConnnectionModel extends PolylineEdgeModel {
      constructor (data, graphModel) {
        super(data, graphModel)
      }

      getEdgeStyle() {
        const style = super.getEdgeStyle();
        const properties = this.properties;
        if (properties.condition_value === '1') {
          style.stroke = "green";
        } else if (properties.condition_value === '-1') {
          style.stroke = "red";
        } else {
          style.stroke = "#000000";
        }
        return style;
      }

      getEdgeAnimationStyle() {
        const style = super.getEdgeAnimationStyle();
        const properties = this.properties;
        if (properties.condition_value === '1') {
          style.stroke = "green";
        } else if (properties.condition_value === '-1') {
          style.stroke = "red";
        } else {
          style.stroke = "#000000";
        }
        style.strokeDasharray = "5 5";
        style.animationDuration = "30s";
        return style;
      }
    }
    return {
      view: PolylineEdge,
      model: ConnnectionModel
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/registerNode/registerPolyline.js